import { get, post } from "../utils/request";
import CryptData from "../utils/cryptData";

/**
 * 获取拍卖中心当前期数信息
 * @param {*} vm
 * @param {*} cb
 */
export const auctionNow = (vm, cb) => {
  post("/api/auction/tnperNow")
    .then(res => {
      /* 
        nowNper 当前期数
        notStartNper 未开始期数
      */
      if (
        res.code === 200 &&
        res.data != null &&
        res.data != undefined &&
        JSON.stringify(res.data) !== "{}"
      ) {
        vm.haveAuction = true;
        if (res.data.nowNper && res.data.notStartNper) {
          vm.nowObj = res.data.nowNper || {};
        } else if (res.data.nowNper) {
          vm.nowObj = res.data.nowNper || {};
        } else {
          vm.nowObj = res.data.notStartNper || {};
        }
        vm.nowObj.imgUrl = vm.nowObj.imgUrl
          ? vm.comImgUrl + vm.nowObj.imgUrl.split("|")[0]
          : "";

        if (vm.nowObj.transactionType !== 2) {
          if (vm.setTime) {
            vm.setTime();
          }
        }
        if (vm.setPersonNum) {
          vm.numObj = vm.setPersonNum(vm.nowObj.list || []);
        }
      } else {
        vm.haveAuction = false;
      }
      vm.$tips_msg(vm, res);
      cb && cb(res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取拍卖中心往期回顾列表
 * @param {*} vm
 * @param {*} cb
 */
export const auctionPastList = (vm, cb) => {
  let param = {
    pageNo: vm.current,
    pageSize: vm.display
  };
  vm.list = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/auction/tnperList", param)
    .then(res => {
      vm.isloading = false;
      if (res.code == 200) {
        vm.list = res.data.list.map(item => {
          let numobj = vm.setPersonNum(item.list || []);
          item.joinNumber = numobj.joinNumber;
          item.visitorsNumber = numobj.visitorsNumber;
          item.remindNumber = numobj.remindNumber;
          item.imgUrl = item.imgUrl
            ? vm.comImgUrl + item.imgUrl.split("|")[0]
            : "";
          return item;
        });

        vm.total = res.data.total;
      }
      vm.nodata = vm.list.length == 0 ? true : false;

      vm.$tips_msg(vm, res);
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.list.length == 0 ? true : false;
      vm.$tips_error(vm, error);
    });
};

/**
 * 通过Id 获取拍卖期数详情
 * @param {*} vm
 * @param {*} cb
 */
export const getAuctionById = (vm, cb) => {
  let params = {
    id: vm.auctionId
  };
  post("/api/auction/searchTnperInfoById", params)
    .then(res => {
      if (res.code === 200) {
        var obj = res.data.tnper || {};
        vm.nowObj = res.data.tnper || {};
        vm.nowObj.imgUrl = vm.nowObj.imgUrl
          ? vm.comImgUrl + vm.nowObj.imgUrl.split("|")[0]
          : "";
        if (vm.nowObj.transactionType !== 2) {
          if (obj.transactionType != 2) {
            switch (obj.transactionType) {
              case 0:
                //未开始
                var timer = vm.$publicMethods.formatTime(obj.startDate);
                var starttime = new Date(timer).getTime();
                var nowtime = new Date().getTime();
                if (nowtime < starttime) {
                  vm.setTime();
                }
                break;
              case 1:
                //进行中
                var timer1 = vm.$publicMethods.formatTime(obj.expectEndDate);
                var endtime1 = new Date(timer1).getTime();
                var nowtime1 = new Date().getTime();
                if (nowtime1 < endtime1) {
                  vm.setTime();
                }
                break;
              default:
                break;
            }
          }
        }
        vm.setPersonNum(res.data.list || []);
      }
      vm.$tips_msg(vm, res);
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取当期期数拍卖列表
 * @param {*} vm
 * @param {*} cb
 */
export const getNowAuctionList = (vm, cb) => {
  let params = {
    nperId: vm.auctionId,
    name: vm.keyword,
    pageNo: vm.current,
    pageSize: vm.display
  };
  if (vm.tabStatus !== 0) {
    params.transactionType = vm.tabStatus;
  }
  vm.list = [];
  vm.isloading = true;
  vm.nodata = false;
  post("/api/auction/selectTnperInfoByType", params)
    .then(res => {
      vm.isloading = false;
      if (res.code === 200) {
        vm.total = res.data.total;
        // vm.list = res.data.list || [];
        vm.list = res.data.list.map(item => {
          item.imgsUrl = item.imgsUrl
            ? vm.comImgUrl + item.imgsUrl.split("|")[0]
            : "";
          return item;
        });
      }
      vm.nodata = vm.list.length == 0 ? true : false;
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.isloading = false;
      vm.nodata = vm.list.length == 0 ? true : false;
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**=============================== */

/**
 * 拍卖详情
 * @param {实例对象this} vm
 * @param {回调函数} cb
 */
export const auctionDetail = (vm, cb) => {
  let param = {
    id: vm.detailId
  };
  post("/api/auction/auctionTnperSearchById", param)
    .then(res => {
      //console.log(res);
      if (res.code === 200) {
        let obj = res.data;
        /* //auctionStatus  0 拍卖中 1 已中拍 2 无人拍造成流拍  3逾期未付款造成流拍 4 未开始',
        //detailType  拍卖详情状态，0 => 未开始，1 => 正在拍卖，2 => 已结束
        auctionType 0 => 秒杀 1=》普通
        switch (obj.auctionStatus) {
          case 1:
          case 2:
          case 3:
            vm.detailType = 2;
            break;
          case 0:
            vm.detailType = 1;
            break;
          default:
            vm.detailType = 0;
            break;
        } */

        //transaction_type  表示拍品  0 未开始 1 进行中 2 已结束
        vm.detailObj = obj;
        vm.detailObj.EndDate = obj.endDate ? obj.endDate : obj.expectEndDate;
        vm.detailType = obj.transactionType;
        vm.imglist = obj.imgsUrl ? obj.imgsUrl.split("|") : [];

        vm.imglist = vm.imglist.map(element => {
          element = vm.comImgUrl + element;
          return element;
        });
        vm.detailObj.videoUrl = vm.detailObj.videoUrl
          ? vm.comImgUrl + vm.detailObj.videoUrl
          : "";
        //console.log(vm.detailObj.videoUrl);
        vm.imgView = vm.imglist.length > 0 ? vm.imglist[0] : "";

        if (obj.transactionType != 2) {
          switch (obj.transactionType) {
            case 0:
              //未开始
              var timer = vm.$publicMethods.formatTime(obj.startDate);
              var starttime = new Date(timer).getTime();
              var nowtime = new Date().getTime();
              vm.auctionPrice = vm.detailObj.startPrice;
              if (nowtime < starttime) {
                vm.setTime();
                // vm.refreshData();
              }
              break;
            case 1:
              //进行中
              var timer1 = vm.$publicMethods.formatTime(obj.endDate);
              var endtime1 = new Date(timer1).getTime();
              var nowtime1 = new Date().getTime();
              if (nowtime1 < endtime1) {
                vm.setTime();
              }
              break;
            default:
              break;
          }
        }

        if (vm.detailType !== 0) {
          vm.tabList.splice(vm.tabList.length - 1, 1, {
            name: "出价记录",
            active: false,
            isShow: true
          });
          auctionBidRecord(vm);
        }
        auctionDetailAfter(vm);

        vm.refreshData();
      }
      vm.$tips_msg(vm, res);
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 拍卖详情售后&&流程
 * @param {实例对象this} vm
 * @param {回调函数} cb
 */
export const auctionDetailAfter = (vm, cb) => {
  let param = {
    id: vm.detailId
  };
  post("/api/auctionNper/selectAfterSaleById", param)
    .then(res => {
      if (res.code === 200) {
        vm.afterDelivery = res.data.afterDelivery;
        vm.auctionProcess = res.data.auctionProcess;
      }
      vm.$tips_msg(vm, res);
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 拍卖详情出价记录
 * @param {实例对象this} vm
 * @param {回调函数} cb
 */
export const auctionBidRecord = (vm, cb) => {
  let param = {
    goodsId: vm.detailObj.auctionId
  };
  post("/api/auction/bidListByGoodsId", param)
    .then(res => {
      vm.refreshLoading = false;
      if (res.code === 200) {
        vm.recordList = res.data
          ? res.data.map(item => {
              if (!item.frontUser) {
                item.frontUser = {};
              }
              // item.bidDate = vm.$publicMethods.formatDate(item.bidDate);
              return item;
            })
          : [];
        vm.placardCount = vm.recordList.length;
        if (vm.recordList.length == 0) {
          vm.nowPrice = vm.detailObj.startPrice;
          vm.auctionPrice = parseFloat(vm.detailObj.startPrice); //输入价格
        } else {
          vm.nowPrice = parseFloat(vm.recordList[0].bidPrice);
          vm.auctionPrice = vm.detailObj.raisePriceRange
            ? vm.nowPrice + parseFloat(vm.detailObj.raisePriceRange)
            : vm.nowPrice;
        }
      }
      vm.$tips_msg(vm, res);
      if (cb !== undefined) {
        cb(res);
      }
    })
    .catch(error => {
      vm.refreshLoading = false;
      //console.log(error);
      vm.$tips_error(vm, error);
    });
};

/**
 * 设置提醒
 * @param {*} vm
 * @param {*} cb
 */
export const setAuctionLock = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    goodsId: vm.detailObj.auctionId,
    remindDate: vm.detailObj.startDate
  };
  post("/api/auction/addRemind", params)
    .then(res => {
      if (res.code === 200 && res.data != "reminded") {
        vm.$notify({
          title: "提示",
          message: "设置成功",
          type: "success"
        });
      } else if (res.code === 200 && res.data == "reminded") {
        vm.$notify({
          title: "提示",
          message: "您已设置过提醒！",
          type: "info"
        });
      } else {
        vm.$notify({
          title: "提示",
          message: "设置失败：" + res.message,
          type: "error"
        });
      }

      cb && cb(res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 统计浏览人数
 * @param {*} vm
 * @param {*} cb
 */
export const setVisitorsNumber = (vm, cb) => {
  let params = {
    id: vm.detailId
  };
  post("/api/auctionNper/updatevisitorsNumber", params)
    .then(res => {
      if (cb !== undefined) {
        cb(res);
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取当期拍品最新出价
 * @param {*} vm
 * @param {*} cb
 */
export const getNewPayPrice = (vm, cb) => {
  let params = {
    goodsId: vm.detailObj.auctionId
  };
  post("/api/auction/selectByGoodsIdList", params)
    .then(res => {
      if (cb !== undefined) {
        cb(res);
      }
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 举牌
 * @param {*} vm
 * @param {*} cb
 */
export const placard = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    goodsId: vm.detailObj.auctionId,
    nperId: vm.detailObj.nperId,
    bidPrice: vm.auctionPriceCP,
    bidType: 1
  };
  post("/api/auction/addBid", params)
    .then(res => {
      if (res.code === 200) {
        if (res.data === "拍卖已结束") {
          vm.$notify({
            title: "提示",
            message: "拍卖已结束",
            type: "info"
          });
          vm.getdetail();
        } else if (res.data === "PleaseAgain") {
          vm.$notify({
            title: "提示",
            message: "该拍品有更新，请刷新后竞拍",
            type: "error"
          });
        } else if (res.data === "maxnum") {
          vm.$notify({
            title: "提示",
            message: "您已是最高出价",
            type: "info"
          });
        } else {
          vm.$notify({
            title: "提示",
            message: "举牌成功",
            type: "success"
          });
        }
      }
      vm.$tips_msg(vm, res);
      cb && cb(res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 秒杀
 * @param {*} vm
 * @param {*} cb
 */
export const spike = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    goodsId: vm.detailObj.auctionId,
    bidType: 0,
    bidPrice: vm.detailObj.seckillPrice,
    nperId: vm.detailObj.nperId
  };
  post("/api/auction/spikePay", params)
    .then(res => {
      if (res.data && res.data === "PleasePayDeposit") {
        vm.$notify({
          title: "提示",
          message: "请先支付押金",
          type: "warning"
        });
        vm.$refs.modalSpike.isShowLoading = false;
        vm.isShowSpike = false;
      } else {
        cb && cb(res);
      }
      // if (res.code === 200) {
      //   vm.$message({
      //     message: "秒杀成功",
      //     type: "success"
      //   });
      // } else {
      //   vm.$message({
      //     message: "秒杀失败",
      //     type: "error"
      //   });
      // }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 检测用户是否拥有秒杀资格
 * @param {*} vm
 * @param {*} cb
 */
export const hasSpike = (vm, cb) => {
  let params = {
    userId: vm.userInfo.userId,
    auctionId: vm.detailObj.auctionId
  };
  post("/api/auction/payDeposit", params)
    .then(res => {
      if (res) {
        vm.isHasSpike = res.data === "yes" ? true : false;
        cb && cb(res);
      }
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};

/**
 * 获取秒杀用户
 * @param {*} vm
 * @param {*} cb
 */
export const getSpikeUser = (vm, cb) => {
  post("/api/auction/winUser", { goodsId: vm.detailObj.auctionId })
    .then(res => {
      cb && cb(res);
    })
    .catch(error => {
      vm.$refs.modalSpike.isShowLoading = false;
      vm.isShowSpike = false;
      clearTimeout(vm.timerSetTimeout);
      clearTimeout(vm.timerSetTimeoutRe);
      vm.getdetail(vm);
      document.body.className = "";
      vm.$tips_error(vm, error);
    });
};
